export const away = () => {
    if (window.localStorage.getItem('isAway') === 'false') {
        clearTimeout(window.globalAwayTimer);
        window.globalAwayTimer = null;
    }

    if (window.localStorage.getItem('isAway') === 'true' && window.localStorage.getItem('awayStatusLastDate')) {
        if (window.AwayStatusModal) {
            const awayStatusLastDate = new Date(window.localStorage.getItem('awayStatusLastDate')).toISOString();

            const momentAwayStatusLastDate = moment(awayStatusLastDate);
            const currentTime = moment(new Date().toISOString());

            clearTimeout(window.globalAwayTimer);
            window.globalAwayTimer = null;
            const minCount = 240;

            // QA Flow
            if (currentTime.diff(momentAwayStatusLastDate, 'minutes') > minCount) {
                window.AwayStatusModal.showModal();
            } else {
                const timer = (minCount - currentTime.diff(momentAwayStatusLastDate, 'minutes')) * 1000 * 60;

                window.globalAwayTimer = setTimeout(() => {
                    window.AwayStatusModal.showModal();
                    window.localStorage.setItem('isAwayActions', 0);
                }, timer);
            }
        }
    }
}
